import { createContext, useContext } from "react";

// The signed-in user's Key Dates (null while loading), from NudgeApp's one listener. The task editor
// reads them here for its "Key date" field, so every page that opens it gets the field without new props.
export const KeyDatesContext = createContext(null);
export const useKeyDatesList = () => useContext(KeyDatesContext);
